module.exports = __webpack_public_path__ + "static/media/home@2x.624d77da.png";